import React from 'react'
import Modal from 'react-modal'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery'

import { Editor } from '@tinymce/tinymce-react'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './CreateEditSow.css'

const styling = {
    content: {
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        paddingTop: '0px',
        background: 'white',
        paddingLeft: '50px',
        paddingRight: '40px'
    }
}

const CreateEditSow = (
    {
        errSow,
        errSowClear,

        curTemplate,
        curTab,

        templates,
        answers,

        selTemplate,

        modValues,
        updateTab,
        saveProject,
        projectExport,

        create,
        isOpen,

        tabToggle,

        confirmChange,
        confirmChangeYes,
        confirmChangeNo,

        confirmCancel,
        confirmCancelYes,
        confirmCancelNo,

        onAfterOpen,
        onRequestCancel
    }) => (
    <Modal isOpen={isOpen} onAfterOpen={onAfterOpen} style={styling}>
        <CommError error={errSow.error} onClose={errSowClear} />

        <ConfirmModal open={confirmChange} heading={"Change Project Type ?"} msg={"Entered data will be lost"} onNo={confirmChangeNo} onYes={confirmChangeYes} />
        <ConfirmModal open={confirmCancel} heading={"Data Saved ?"} msg={"Unsaved data will be lost on exit"} onNo={confirmCancelNo} onYes={confirmCancelYes} />

        <div className="create-edit-sow productManagement editpages">
            <h1>{create ? 'Edit' : 'Create'} Scope of Work</h1>

            {
                !create && curTab == 0 ?
                    <div className="hdr_container1">
                        <div className="hdr">
                            <label>Project Types:</label><br />
                            <select id="projtypes" onChange={selTemplate}>
                                {
                                    templates.map((template, index) => {
                                        return <option key={index} value={template.projectTypeID}>{template.name}</option>
                                    })
                                }
                            </select>
                        </div>

                        <div className="buttons">
                            {
                                curTab == 0 ?
                                    <a className="btn btn-default" canc="true" onClick={onRequestCancel}>Cancel</a>
                                :
                                    <a className="btn btn-default" onClick={onRequestCancel}>Return to List</a>
                            }
                        </div>
                    </div>
                :
                    <div className="hdr_container2">
                        <div className="project over768">
                            <span>Project ID: </span>
                            {
                                !create ?
                                    <span className="answer">{errSow.sow.projectTypeID}</span>
                                :
                                    <span className="answer">{answers.projectID}</span>
                            }

                            <span className="name">Project Name: </span>
                            {
                                create ?
                                    answers.projectTabs &&
                                    answers.projectTabs[0] &&
                                    answers.projectTabs[0].tabQuestions &&
                                    answers.projectTabs[0].tabQuestions[0] &&
                                    answers.projectTabs[0].tabQuestions[0].questionResults &&
                                    answers.projectTabs[0].tabQuestions[0].questionResults[0] ?
                                        <span id="projname" className="answer">{answers.projectTabs[0].tabQuestions[0].questionResults[0].result}</span>
                                    : null
                                : <span id="projname" className="answer"></span>
                            }
                        </div>
                        <div className="project under768">
                            <span>Project ID: </span>
                            {
                                !create ?
                                    <span className="answer">{errSow.sow.projectTypeID}</span>
                                    :
                                    <span className="answer">{answers.projectID}</span>
                            }

                            <br />

                            <span className="name">Project Name: </span>
                            {
                                create ?
                                    answers.projectTabs &&
                                        answers.projectTabs[0] &&
                                        answers.projectTabs[0].tabQuestions &&
                                        answers.projectTabs[0].tabQuestions[0] &&
                                        answers.projectTabs[0].tabQuestions[0].questionResults &&
                                        answers.projectTabs[0].tabQuestions[0].questionResults[0] ?
                                        <span id="projname" className="answer">{answers.projectTabs[0].tabQuestions[0].questionResults[0].result}</span>
                                        : null
                                    : <span id="projname" className="answer"></span>
                            }

                            <br />

                            <span>Project Type: </span><span>{answers.name}</span>

                        </div>

                        <div className="buttons">
                            <a className="btn btn-default" onClick={onRequestCancel}>Return to List</a>
                        </div>
                    </div>
            }

            {
                templates[curTemplate] ?
                    templates[curTemplate].projectTabs.map((tab, tabindex) => {
                        return <div key={tabindex}>
                            <div className="viewtab_hdr over768" tabindex={tabindex}>
                                {
                                    create && tabindex == 0 ?
                                        <p>{answers.name} - {tab.name}<i className="fa fa-toggle-down pull-right" tabindex={tabindex} onClick={tabToggle}></i></p>
                                    :
                                        <p>{tab.name}<i className="fa fa-toggle-down pull-right" tabindex={tabindex} onClick={tabToggle}></i></p>
                                }
                            </div>
                            <div className="viewtab_hdr under768" tabindex={tabindex}>
                                {
                                    <p>{tab.name}<i className="fa fa-toggle-down pull-right" tabindex={tabindex} onClick={tabToggle}></i></p>
                                }
                            </div>
                            <div className="viewtab" tabindex={tabindex}>
                                <div>
                                    <div className="viewelement">
                                        {
                                            tab.tabQuestions.map((question, questionindex) => {
                                                if (question.questionType == "TB" ||
                                                    question.questionType == "TA" ||
                                                    question.questionType == "DT" ||
                                                    question.questionType == "HCB" ||
                                                    question.questionType == "VCB" ||
                                                    question.questionType == "DD" ||
                                                    question.questionType == "RB" ||
                                                    question.questionType == "LI") {

                                                    return <div className="viewquestion" key={questionindex}>
                                                        <label tabindex={tabindex} class="questlabel" required={question.isRequired}>{question.label}{question.isRequired ? <span>*</span> : null}
                                                            <OverlayTrigger placement="top" overlay={<Tooltip>{question.helpText}</Tooltip>}>
                                                                <i className="fa fa-info-circle"></i>
                                                            </OverlayTrigger>
                                                        </label><br />

                                                        {
                                                            question.questionType == "TB" ?
                                                                <input type="text"
                                                                    questionid={question.questionID}
                                                                    onChange={modValues}
                                                                    tabindex={tabindex}
                                                                    required={question.isRequired ? true : false}
                                                                    defaultValue={
                                                                        create &&
                                                                        answers.projectTabs &&
                                                                        answers.projectTabs[tabindex] &&
                                                                        answers.projectTabs[tabindex].tabQuestions &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex] &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults[0] ?
                                                                            answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults[0].result
                                                                        : null
                                                                    }
                                                                />
                                                            : null
                                                        }

                                                        {
                                                            question.questionType == "TA" ?
                                                                <textarea
                                                                    questionid={question.questionID}
                                                                    onChange={modValues}
                                                                    tabindex={tabindex}
                                                                    required={question.isRequired ? true : false}
                                                                    defaultValue={
                                                                        create &&
                                                                        answers.projectTabs &&
                                                                        answers.projectTabs[tabindex] &&
                                                                        answers.projectTabs[tabindex].tabQuestions &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex] &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults[0] ?
                                                                            answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults[0].result
                                                                        : null
                                                                    }
                                                                />
                                                            : null
                                                        }

                                                        {
                                                            question.questionType == "DT" ?
                                                                <input
                                                                    questionid={question.questionID}
                                                                    onChange={modValues}
                                                                    className="datetime" 
                                                                    type="date"
                                                                    autocomplete="off"
                                                                    tabindex={tabindex}
                                                                    required={question.isRequired ? true : false}
                                                                    defaultValue={
                                                                        create &&
                                                                        answers.projectTabs &&
                                                                        answers.projectTabs[tabindex] &&
                                                                        answers.projectTabs[tabindex].tabQuestions &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex] &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults[0] ?
                                                                            answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults[0].result
                                                                        : null
                                                                    }
                                                                />
                                                            : null
                                                        }

                                                        {
                                                            question.questionType == "HCB" && question.questionOptions ?
                                                                question.questionOptions.map((option, index) => {
                                                                    return <div className="HCB" key={index}>
                                                                        <input
                                                                            type="checkbox"
                                                                            tabindex={tabindex}
                                                                            onChange={modValues}
                                                                            name={question.label}
                                                                            questionoptid={option.questionID}
                                                                            optionid={option.questionOptionID}
                                                                            defaultChecked={
                                                                                create &&
                                                                                answers.projectTabs &&
                                                                                answers.projectTabs[tabindex] &&
                                                                                answers.projectTabs[tabindex].tabQuestions &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex] &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions[index] &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions[index].questionOptionResults &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions[index].questionOptionResults.length ? true : false
                                                                            }
                                                                        /> <span>{option.optionName}</span>
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>{option.helpText}</Tooltip>}>
                                                                            <i className="fa fa-info-circle"></i>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                })
                                                            : null
                                                        }

                                                        {
                                                            question.questionType == "VCB" && question.questionOptions ?
                                                                question.questionOptions.map((option, index) => {
                                                                    return <div className="VCB" key={index}>
                                                                        <input
                                                                            type="checkbox"
                                                                            tabindex={tabindex}
                                                                            onChange={modValues}
                                                                            name={question.label}
                                                                            questionoptid={option.questionID}
                                                                            optionid={option.questionOptionID}
                                                                            defaultChecked={
                                                                                create &&
                                                                                answers.projectTabs &&
                                                                                answers.projectTabs[tabindex] &&
                                                                                answers.projectTabs[tabindex].tabQuestions &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex] &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions[index] &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions[index].questionOptionResults &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions[index].questionOptionResults.length ? true : false
                                                                            }
                                                                        /> <span>{option.optionName}</span>
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>{option.helpText}</Tooltip>}>
                                                                            <i className="fa fa-info-circle"></i>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                })
                                                            : null
                                                        }

                                                        {
                                                            question.questionType == "DD" && question.questionOptions ?
                                                                <select
                                                                    tabindex={tabindex}
                                                                    onChange={modValues}
                                                                    name={question.label}
                                                                    questionseloptid={question.questionID}
                                                                    defaultValue={
                                                                        create &&
                                                                        answers.projectTabs &&
                                                                        answers.projectTabs[tabindex] &&
                                                                        answers.projectTabs[tabindex].tabQuestions &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex] &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions.filter((question) => { return question.questionOptionResults.length }).length ?
                                                                            answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions.filter((question) => { return question.questionOptionResults.length })[0].optionName : ""
                                                                    }
                                                                >
                                                                    <option>Select</option>
                                                                    {
                                                                        question.questionOptions.map((option, index) => {
                                                                            return <option key={index} value={option.questionOptionID}>{option.optionName}</option>
                                                                        })
                                                                    }
                                                                </select>
                                                            : null
                                                        }

                                                        {
                                                            question.questionType == "RB" && question.questionOptions ?
                                                                question.questionOptions.map((option, index) => {
                                                                    return <div className="RB" key={index}>
                                                                        <input
                                                                            type="radio"
                                                                            tabindex={tabindex}
                                                                            onChange={modValues}
                                                                            name={question.label}
                                                                            questionoptid={option.questionID}
                                                                            optionid={option.questionOptionID}
                                                                            defaultChecked={
                                                                                create &&
                                                                                answers.projectTabs &&
                                                                                answers.projectTabs[tabindex] &&
                                                                                answers.projectTabs[tabindex].tabQuestions &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex] &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions[index] &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions[index].questionOptionResults &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions[index].questionOptionResults.length ? true : false
                                                                            }

                                                                        /> <span>{option.optionName}</span>
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>{option.helpText}</Tooltip>}>
                                                                            <i className="fa fa-info-circle"></i>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                })
                                                            : null
                                                        }

                                                        {
                                                            question.questionType == "LI" ?
                                                                <Editor
                                                                    initialValue={$('<div>').html(
                                                                        create &&
                                                                        answers.projectTabs &&
                                                                        answers.projectTabs[tabindex] &&
                                                                        answers.projectTabs[tabindex].tabQuestions &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex] &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults[0] ?
                                                                            answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults[0].result
                                                                        : null).text()}
                                                                    questionid={question.questionID}
                                                                    init={
                                                                        {
                                                                            menubar: false,
                                                                            branding: false,
                                                                            elementpath: false,
                                                                            plugins: "lists advlist link image textcolor table hr code",
                                                                            toolbar: false
                                                                        }
                                                                    }
                                                                    apiKey="8e64hzacbayfd5osxbwkwtn1120t8xrh7wg526cs6ox73d3e"
                                                                    tabindex={tabindex} required={question.isRequired ? true : false}
                                                                />
                                                            : null
                                                        }
                                                    </div>
                                                }
                                            })
                                        }
                                    </div>
                                    <div className="viewelement">
                                        <div id="instructions"></div>
                                        {
                                            tab.tabQuestions.map((question, questionindex) => {
                                                if (question.questionType == "RTA" ||
                                                    question.questionType == "RI") {

                                                    return <div className="viewquestion" key={questionindex}>
                                                        <label tabindex={tabindex} class="questlabel" required={question.isRequired}>{question.label}{question.isRequired ? <span>*</span> : null}
                                                            <OverlayTrigger placement="top" overlay={<Tooltip>{question.helpText}</Tooltip>}>
                                                                <i className="fa fa-info-circle"></i>
                                                            </OverlayTrigger>
                                                        </label><br />

                                                        {
                                                            question.questionType == "RTA" ?
                                                                <textarea
                                                                    questionid={question.questionID}
                                                                    onChange={modValues}
                                                                    tabindex={tabindex}
                                                                    required={question.isRequired ? true : false}
                                                                    defaultValue={
                                                                        create &&
                                                                        answers.projectTabs &&
                                                                        answers.projectTabs[tabindex] &&
                                                                        answers.projectTabs[tabindex].tabQuestions &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex] &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults[0] ?
                                                                            answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults[0].result
                                                                        : null
                                                                    }
                                                                />
                                                            : null
                                                        }

                                                        {
                                                            question.questionType == "RI" ?
                                                                <Editor
                                                                    initialValue={$('<div>').html(
                                                                        create &&
                                                                        answers.projectTabs &&
                                                                        answers.projectTabs[tabindex] &&
                                                                        answers.projectTabs[tabindex].tabQuestions &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex] &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults &&
                                                                        answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults[0] ?
                                                                            answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults[0].result
                                                                        : null).text()}
                                                                    questionid={question.questionID}
                                                                    init={
                                                                        {
                                                                            menubar: false,
                                                                            branding: false,
                                                                            elementpath: false,
                                                                            plugins: "lists advlist link image textcolor table hr code",
                                                                            toolbar: false
                                                                        }
                                                                    }
                                                                    apiKey="8e64hzacbayfd5osxbwkwtn1120t8xrh7wg526cs6ox73d3e"
                                                                    tabindex={tabindex} required={question.isRequired ? true : false}
                                                                />
                                                            : null
                                                        }
                                                    </div>
                                                }
                                            })
                                        }
                                    </div>
                                </div>

                                <button className="btn btn-primary next" tabid={tab.projectTabId} tabindex={tabindex} onClick={updateTab}>Save & Continue to Next Tab</button>
                            </div>
                        </div>
                    })
                : null
            }
                
            {
                templates[curTemplate] && templates[curTemplate].projectTabs.length ?
                    <div>
                        <div className="viewtab_hdr" tabindex={templates[curTemplate].projectTabs.length}>
                            <p>Review<i className="fa fa-toggle-down pull-right" tabindex={templates[curTemplate].projectTabs.length} onClick={tabToggle}></i></p>
                        </div>
                            <div className="viewtab" tabindex={templates[curTemplate].projectTabs.length}>
                            <div className="review">
                                <table className="revision">
                                    <tbody>
                                        <tr>
                                            <th>Revision:</th>
                                            <td>{answers.version ? answers.version : null}</td>
                                        </tr>
                                        {
                                            answers.projectTabs && answers.projectTabs.length ?
                                                answers.projectTabs[0].tabQuestions.map((question, index) => {
                                                    if (question.isActive && !question.isDeleted) {
                                                        if (question.questionResults.length) {
                                                            return <tr key={index}>
                                                                <th>{question.label}</th>
                                                                <td>{question.questionResults[0].result}</td>
                                                            </tr>
                                                        }
                                                        else if (question.questionOptions.length) {
                                                            return <tr key={index}>
                                                                <th>{question.label}</th>
                                                                <td>
                                                                {
                                                                    question.questionOptions.map((option, index) => { 
                                                                        if (option.questionOptionResults.length) {
                                                                            return <span className="option" key={index}>{option.optionName} </span>
                                                                        }
                                                                    })
                                                                }
                                                                </td>
                                                            </tr>
                                                        }
                                                    }
                                                })
                                            : null
                                        }
                                    </tbody>
                                </table>
                            </div>

                            <div className="review">
                                <label>Work Details:</label>
                                <table className="details">
                                    <tbody>
                                        <tr>
                                            <td>Work Category</td>
                                            <td>Work Needed</td>
                                        </tr>
                                        {
                                            templates[curTemplate].projectTabs.map((tab, tabindex) => {
                                                if (tab.active && !tab.deleted && tabindex > 0) {
                                                    return <tr key={tabindex}>
                                                        <td>{tab.name}</td>
                                                        <td>
                                                        {
                                                            templates[curTemplate].projectTabs[tabindex].tabQuestions.map((question, questionindex) => {
                                                                if (question.isActive && !question.isDeleted) {
                                                                    return <div key={questionindex}>
                                                                        <div className="questlbl quests">
                                                                            <span>{question.label}: </span>
                                                                        </div>
                                                                        <div className="questopts quests">
                                                                        { 
                                                                            answers.projectTabs && 
                                                                            answers.projectTabs[tabindex] &&
                                                                            answers.projectTabs[tabindex].tabQuestions &&
                                                                            answers.projectTabs[tabindex].tabQuestions[questionindex] &&
                                                                            answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults && 
                                                                            answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults.length ?
                                                                                <div className="option"><span>{answers.projectTabs[tabindex].tabQuestions[questionindex].questionResults[0].result}</span></div>

                                                                            :

                                                                                answers.projectTabs &&
                                                                                answers.projectTabs[tabindex] &&
                                                                                answers.projectTabs[tabindex].tabQuestions &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex] &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions &&
                                                                                answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions.length ?
                                                                                    answers.projectTabs[tabindex].tabQuestions[questionindex].questionOptions.map((option, index) => {
                                                                                        if (option.questionOptionResults.length) {
                                                                                            return <div className="option"><span className="option" key={index}>{option.optionName}<span className="optionseparator">,</span></span></div>
                                                                                        }
                                                                                    })
                                                                                : null
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                }
                                                            })
                                                        }
                                                        </td>
                                                    </tr>
                                                }
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>

                            <div className="review-btns">
                                <button className="btn btn-primary" onClick={saveProject}>Save Scope of Work</button>
                                <button className="btn btn-primary" proj={answers.projectID} onClick={projectExport}>Print PDF</button>
                           </div>
                        </div>
                    </div>
                : null
            }
            </div>
    </Modal>
);

// Modal.setAppElement('body');
        
export default CreateEditSow